const mutations = {

  getJobvacancy: (state, jobvacancy) => {
    state.jobvacancy = jobvacancy;
  },
  getJobvacancyid: (state, jobvacancy_id) => {
    state.jobvacancy_id = jobvacancy_id;
  },
  getJobtype: (state, jobtype) => {
    state.jobtype = jobtype;
  },
  getJobtype: (state, jobtype) => {
    state.jobtype = jobtype;
  },
  getJobexperience: (state, jobexperience) => {
    state.jobexperience = jobexperience;
  },
  postJobvacancy: (state, new_jobvacancy) => {
    state.jobvacancy.push(new_jobvacancy);
  },
  putJobvacancy: (state, payload) => {
    state.jobvacancy = state.jobvacancy.map((jobvacancy) => {
      if (jobvacancy.id === payload.id) {
        return Object.assign({}, jobvacancy, payload.formData);
      }
      return jobvacancy;
    });
  },
  delJobvacancy(state, id) {
    const index = state.jobvacancy.findIndex(jobvacancy => jobvacancy.id == id);
    state.jobvacancy.splice(index, 1);
  },

};

export default mutations;
